module.exports = __webpack_public_path__ + "img/cuidan.1641520899224.png";